import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
  FormBuilder,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AccountAuthService } from '../../shared/account-auth.service';

@Component({
  selector: 'app-account-signup',
  imports: [CommonModule, ReactiveFormsModule, RouterModule],
  templateUrl: './account-signup.html',
  styleUrl: './account-signup.scss',
})
export class AccountSignup {
  private readonly fb = inject(FormBuilder);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly auth = inject(AccountAuthService);

  readonly form = this.fb.nonNullable.group({
    name: ['', [Validators.required, Validators.maxLength(255)]],
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required, Validators.minLength(8)]],
    confirmPassword: ['', [Validators.required, Validators.minLength(8)]],
  });

  readonly emailLocked: boolean;

  isLoading = false;
  errorMessage = '';

  constructor() {
    const emailParam =
      this.route.snapshot.queryParamMap.get('email')?.trim() ?? '';
    this.emailLocked = emailParam.length > 0;
    if (this.emailLocked) {
      this.form.controls.email.setValue(emailParam);
    }
  }

  submit() {
    if (this.form.invalid || this.isLoading) {
      this.form.markAllAsTouched();
      return;
    }

    const { name, email, password, confirmPassword } = this.form.getRawValue();
    if (password !== confirmPassword) {
      this.form.controls.confirmPassword.setErrors({ mismatch: true });
      this.form.controls.confirmPassword.markAsTouched();
      this.errorMessage = 'Passwords do not match.';
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';

    this.auth.createAccount({ name, email, password }).subscribe({
      next: () => {
        this.isLoading = false;
        this.router.navigate(['/account/verify']);
      },
      error: (message: string) => {
        this.isLoading = false;
        this.errorMessage = message;
      },
    });
  }
}
